import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getMyPlan: {
    method: 'GET',
    url: `${configs.baseUrl}/api/pricing/my-plan/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}
const getMyPlan = () => {
  return resource.getMyPlan()
}

export default {
  initResource,
  getMyPlan,
}
